import React from "react";
import styles from "./ApplicantDetailSidebarFooter.module.scss";
import { Button, Intent } from "@blueprintjs/core";

export function ApplicantDetailSidebarFooter({
  type,
  onApprove,
  onReject,
  onDismissSidebar,
  isReadOnly
}) {
  return (
    <div className={styles.rightSidebarFooter}>
      <div className={styles.seperatorLine}></div>
      <div className={styles.footerContent}>
        <Button onClick={onDismissSidebar}>Cancel</Button>
        {type == "influencer" ? (
          <Button
            className="filled"
            intent={Intent.DANGER}
            onClick={onReject}
            disabled={isReadOnly}
          >
            Remove from Opportunity
          </Button>
        ) : (
          <>
            <Button 
            className="filled" 
            onClick={onApprove}
            disabled={isReadOnly}
            >
              Approve
            </Button>
            <Button 
            className="filled warning" 
            onClick={onReject}
            disabled={isReadOnly}
            >
              Decline
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
